<div class="d-flex flex-row align-content-center gap-2">
    <app-loading-button size="small" class="h-100" classes="btn-ins" [loading]="onSync" (click)="syncVital()">
        {{ 'inclusion.identity.vital.button' | translate }}
    </app-loading-button>
    <div class="d-flex align-content-center flex-wrap pe-2">
        <div class="margin-0-fit-content pe-1" translate="inclusion.identity.vital.state"></div>
        <app-check *ngIf="synced"></app-check>
        <app-xmark *ngIf="!synced"></app-xmark>
    </div>
</div>
